import type { ApiResult } from '@/infra/api'
import { API_ENDPOINTS, httpGet, httpPost } from '@/infra/api'
import type { HostAddRequest, HostAddResponse, HostListItem } from '../types'

export const hostClient = {
  addHost(request: HostAddRequest): Promise<ApiResult<HostAddResponse>> {
    return httpPost<HostAddResponse>(API_ENDPOINTS.HOST_ADD, request)
  },

  listHosts(): Promise<ApiResult<readonly HostListItem[]>> {
    return httpGet<readonly HostListItem[]>(API_ENDPOINTS.HOST_LIST)
  },
}
